export const ExtrapolationColors = {
  overrideValue: '#EAB54E',
  warning: '#F4805B',
};
